var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wordmark',_vm._g(_vm._b({staticClass:"wordmark"},'Wordmark',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }